import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// @ts-ignore: Ignore CSS side-effect import type error
import "./App.css";
import reportWebVitals from "./reportWebVitals";
import { ReferencesProvider, TriviaProvider, UserProvider } from "./context";

import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { UiProvider } from "./context/ui";
import { PodcastPlayerProvider } from "./context/player/Player";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <UiProvider>
      <TriviaProvider>
        <UserProvider>
          <ReferencesProvider>
            
              <PodcastPlayerProvider>
                <App />
              </PodcastPlayerProvider>
            
          </ReferencesProvider>
        </UserProvider>
      </TriviaProvider>
    </UiProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
